import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=f282fefa&scoped=true&"
import script from "./Personal.vue?vue&type=script&lang=js&"
export * from "./Personal.vue?vue&type=script&lang=js&"
import style0 from "./Personal.vue?vue&type=style&index=0&id=f282fefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f282fefa",
  null
  
)

export default component.exports